import * as z from "zod";
import { normalizeName } from "./normalizeName";

export const MAX_USER_GROUP_NAME_LENGTH = 50;

export const groupNameSchema = z
  .string()
  .min(1, { message: "Group name is required" })
  .max(MAX_USER_GROUP_NAME_LENGTH, {
    message: `Group name must be ${MAX_USER_GROUP_NAME_LENGTH} characters or less`,
  })
  .transform(normalizeName)
  .refine((n) => n.length > 0, {
    message: "Group name must contain at least one visible character",
  });
